import Image from "next/image";

import { StrapiImage, StrapiImageProps } from "ui/StrapiImage";
import { useI18n } from "utils/with-i18n.utils";

type AdvantagesBannerProps = {
  modelName: string;
  brand: string;
  image: StrapiImageProps["image"];
};

export const AdvantagesBanner = ({
  modelName,
  brand,
  image,
}: AdvantagesBannerProps) => {
  const i18n = useI18n();
  const model = `${brand == "Apple" ? "L'" : "Le "}${modelName}`;

  return (
    <div className="flex overflow-hidden flex-col pt-10 w-full max-h-[350px] bg-pastel-green-2 rounded-xl lg:max-h-[350px]">
      <p className="px-2 text-2xl font-light text-center text-white lg:text-3xl">
        {i18n.t(
          "product.seo.advantages.subtitle",
          { modelName: model },
          { html: true },
        )}
      </p>
      <div className="relative h-[900px]">
        <div className="absolute top-5 -right-16 w-[800px] h-[1000px] bg-white rounded-full sm:right-10 xl:right-[110px] xs:w-[1000px]"></div>
        <div className="absolute top-auto right-2 lg:bottom-2">
          <Image
            src="/content/icons/logo-nr.webp"
            width={95}
            height={95}
            alt="NR certif logo"
          />
        </div>
        <div className="flex absolute top-1 left-0 gap-10 items-center p-6 !pt-16 w-full h-full sm:!pt-6 lg:justify-center lg:p-0">
          <div className="hidden relative justify-center w-[320px] h-[450px] translate-y-1/4 lg:block">
            <StrapiImage image={image} size="large" />
          </div>

          <section className="flex flex-col gap-5 lg:pr-28">
            <article className="flex gap-3">
              <Image
                src="/content/icons/battery-green.svg"
                width={25}
                height={25}
                alt="green battery icon"
              />
              <p>
                {i18n.t("product.seo.advantages.firstLine", {}, { html: true })}
              </p>
            </article>
            <article className="flex gap-3">
              <Image
                src="/content/icons/sync-green.svg"
                width={25}
                height={25}
                alt="green sync icon"
              />
              <p>
                {i18n.t(
                  "product.seo.advantages.secondLine",
                  {},
                  { html: true },
                )}
              </p>
            </article>
            <article className="flex gap-3">
              <Image
                src="/content/icons/calendar-green.svg"
                width={25}
                height={25}
                alt="green calendar icon"
              />
              <p>
                {i18n.t("product.seo.advantages.thirdLine", {}, { html: true })}
              </p>
            </article>
            <article className="flex gap-3">
              <Image
                src="/content/icons/security-green.svg"
                width={25}
                height={25}
                alt="green security icon"
              />
              <p>
                {i18n.t(
                  "product.seo.advantages.fourthLine",
                  {},
                  { html: true },
                )}
              </p>
            </article>
          </section>
        </div>
      </div>
    </div>
  );
};
